import { useEffect, useState } from "react";

import useFonts from "utilities/hooks/useFonts";
import useTheme from "utilities/hooks/useTheme";

const useThemeOptions = () => {
  const [currentTheme] = useTheme();
  const [currentFonts] = useFonts();
  currentTheme

  const style = getComputedStyle(document.body);

  //220 38 38 is red-700 from https://tailwindcss.com/docs/text-color
  const [colors, setColors] = useState({
    primary: style.getPropertyValue("--color-primary"),
    warning: "220 38 38",
    text: style.getPropertyValue("--color-text-normal"),
  });

  const [fonts, setFonts] = useState({
    body: style.getPropertyValue("--font-body"),
  });

  useEffect(() => {
    const style = getComputedStyle(document.body);

    const colors = {
      primary: style.getPropertyValue("--color-primary"),
      warning: "220 38 38",
      text: style.getPropertyValue("--color-text-normal"),
    };

    const fonts = {
      body: style.getPropertyValue("--font-body"),
    };

    setColors(colors);
    setFonts(fonts);
  }, [currentTheme, currentFonts]);

  return { colors, fonts };
};

export default useThemeOptions;
